<template>
  <div id="GeocodeList">
    <el-row>
      <el-col>
        <Title
          title="Geocodificar lista de puntos"
          subtitle="Edita las direcciones no encontradas"/>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col>
        <search-address @search="getSearchPoints"/>
      </el-col>
    </el-row>
    <el-row v-loading="loading">
      <template v-if="!dataCalled">
        <div class="container-empty">
          <div class="hero">
            <div class="title">Selecciona las opciones para obtener puntos a geocodificar</div>
            <div>
              <p><strong><i>Elige fecha y región, elegir localidad es opcional</i></strong></p>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <el-row class="count-text">
          <div class="left">Resultado de búsqueda: <span>{{totalSize}}</span> puntos</div>
          <div class="right"><span>{{totalCount}}</span> Entregas a clientes</div>
        </el-row>
        <el-row class="progress-bar">
          <el-progress :percentage="currentProgress"
                       :stroke-width="2"
                       :text-inside="false"
                       :showText="false"
                       :color="customColor"></el-progress>
        </el-row>
        <el-row>
          <div class="sideForm">
            <el-col :span="listSize" class="do-body">
              <GeocodingUl v-bind:dataList="subSocs"
                           :dateRange="filter"
                           @AddExamples="AddExamples"
                           @selected="changeDisplayInfo">
              </GeocodingUl>
              <el-row>
                <el-col>
                  <el-pagination layout="sizes, total, prev, pager, next"
                                 @current-change="handleCurrentChange"
                                 @size-change="handleSizeChange"
                                 :page-size="pageSize"
                                 :page-sizes="pageSizes"
                                 :total="currentSize"
                                 :pager-count="5"
                                 style="float:left;">
                  </el-pagination>
                  <el-tooltip placement="top">
                    <div slot="content">Acualmente tienes
                      <span class="focus small">{{currentSize}}</span> puntos
                      cargados de un total de
                      <span class="focus small"> {{totalSize}}</span>
                      para cargar más presiona este botón
                    </div>
                    <el-button class="plus-btn"
                               size="mini"
                               round
                               v-if="totalSize > currentSize"
                               :disabled="partialLoad"
                               @click="loadOneMore">
                      <i v-if="partialLoad" class="fa fa-spinner fa-pulse"></i>
                      <span v-else>+</span>
                    </el-button>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="setGeoSize">
              <GeocodeAssistV3 :input_place="place"
                               :socsMode="false"
                               :selected="oneSelected"
                               @updating="waitingUpdatePoint"/>
            </el-col>
          </div>
        </el-row>
      </template>
    </el-row>
  </div>
</template>

<script>
import { apiRequest } from '@/backend/vue-axios/axios';
import { decodeRSA } from '@/mixins/function';
import Title from '../components/base/Title.vue';
import GeocodingUl from '../components/geocodingV2/GeocodingUl.vue';
import GeocodeAssistV3 from '../components/geocodingV2/GeocodeAssistV3.vue';
import SearchAddress from '../components/geocodingV2/Search.vue';
import { getRumDuration, startRumTiming, trackBusinessFlow } from '@/observability/datadogRum';

export default {
  name: 'ViewGeocodeList',
  components: {
    Title,
    GeocodingUl,
    SearchAddress,
    GeocodeAssistV3,
  },
  data() {
    return {
      filter: {
        dateFrom: null,
        dateUp: null,
      },
      oneSelected: false,
      searchParameters: {},
      totalCount: 0,
      pageSizes: [10, 20, 30, 40, 50, 100],
      dataCalled: false,
      customColor: '#cfcfcf',
      loading: false,
      suborders: [],
      geoTypes: [
        '-',
        'Origen',
        'Exacta',
        'Interpolada',
        'Centroide',
        'Aproximada',
        'Asistida',
        'Manual',
        'Corregido',
        'No encontrado'],
      partialLoad: false,
      pageSize: 10,
      totalSize: 0,
      currentPage: 0,
      listSize: 10,
      setGeoSize: 14,
      displayInfo: {},
      dataDesk: [{
        notFound: {
          title: 'A geocodificar',
          data: 0,
          total: 0,
        },
      }],
      place: {},
      zoom: 10,
      latlng: {},
      customer: {
        full_name: 'Ian',
        phone: '81990687',
      },
      switch_on: true,
    };
  },
  methods: {
    setPointAfterUpdate(pointId, params) {
      if (this.searchParameters.geo_id.includes(params.geo_state_id)) {
        const point = this.suborders.find(e => e.point_id === pointId);
        point.waitingUpdate = false;
        point.latitude = JSON.stringify(params.latitude);
        point.longitude = JSON.stringify(params.longitude);
        point.geo_state = JSON.stringify(params.geo_state_id);
        point.geo_name = this.geoTypes[params.geo_state_id]; // TODO: Creo que no se usa
        point.email = 'Ti';
        if (pointId === this.place.point_id) {
          this.setPlace(point);
        }
      } else {
        this.suborders.splice(this.suborders.findIndex(e => e.point_id === pointId), 1);
        this.totalSize -= 1;
        if (pointId === this.place.point_id) {
          if (this.suborders.length > 0) {
            this.changeDisplayInfo(this.suborders[0]);
          } else {
            this.oneSelected = false;
            this.defaultPlace();
          }
        }
      }
    },
    defaultPlace() {
      this.place = {
        point_id: 0,
        address: '',
        position: {
          lat: -33.435774,
          lng: -70.660690,
        },
        loc_lat: -33.435774,
        loc_lng: -70.660690,
        commune: '',
        locality: '',
        waiting: false,
        route: '',
        street_number: '',
      };
    },
    waitingUpdatePoint(pointId, params) {
      const p = this.suborders.find(e => e.point_id === pointId);
      p.waitingUpdate = true;
      this.place.waiting = true;
      const startedAt = startRumTiming();
      trackBusinessFlow({
        module: 'geocoding',
        flow: 'manual_geocoding_list',
        action: 'point_update_requested',
        status: 'attempt',
        context: {
          point_id: pointId,
          geo_state_id: params.geo_state_id,
        },
      });
      apiRequest({
        module: 'geocoding',
        service: 'update_location_v2',
        pathparam: { id: pointId },
        params,
      }).then(() => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding_list',
          action: 'point_update_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            point_id: pointId,
            geo_state_id: params.geo_state_id,
          },
        });
        this.$notify({
          type: 'success',
          title: 'Completado',
          message: 'Punto editado correctamente',
        });
        this.setPointAfterUpdate(pointId, params);
      }).catch(() => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding_list',
          action: 'point_update_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            point_id: pointId,
            geo_state_id: params.geo_state_id,
          },
        });
        this.$notify.error({
          title: 'Error',
          message: 'Error al editar punto',
        });
        p.waitingUpdate = false;
        this.place.waiting = false;
      });
    },
    AddExamples(id, examples) {
      this.suborders.find(e => e.point_id === id).gridData = examples;
    },
    setPlace(data) {
      this.place = {
        point_id: data.point_id,
        address: data.address,
        waiting: false,
        position: {
          lat: parseFloat(data.latitude),
          lng: parseFloat(data.longitude),
        },
        loc_lat: parseFloat(data.loc_latitude),
        loc_lng: parseFloat(data.loc_longitude),
        commune: data.commune,
        locality: data.locality,
        route: '',
        street_number: '',
      };
    },
    changeDisplayInfo(data) {
      this.oneSelected = true;
      this.displayInfo = {};
      this.displayInfo = data;
      this.suborders.forEach((e) => {
        if (e.selected) {
          e.selected = false;
        }
      });
      this.suborders.find(e => e.point_id === data.point_id).selected = true;
      this.setPlace(data);
    },
    getSearchPoints(params) {
      // TODO getPoints
      const orderBy = params.order ? 'asc' : 'desc';
      const startedAt = startRumTiming();
      this.loading = true;
      // eslint-disable-next-line no-array-constructor
      this.suborders = Array();
      this.currentPage = 0;
      this.defaultPlace();
      this.oneSelected = false;
      this.totalSize = 0;
      this.filter = {
        dateFrom: params.dateRange[0],
        dateUp: params.dateRange[1],
      };
      this.searchParameters = {
        region_id: params.regions, // TODO: Pasar de ID > ARRAY
        document_id: params.documentTypes, // TODO: Agregar, es array
        locality_id: params.localities,
        date: params.dateRange[0],
        end_date: params.dateRange[1],
        order: orderBy,
        offset: 0,
        locality_order: orderBy,
        geo_id: params.geoTypes,
        size: this.pageSize,
      };

      // get count
      apiRequest({
        module: 'geocoding',
        service: 'get_points_total_v2',
        params: this.searchParameters,
      }).then((response) => {
        this.totalCount = response.data.count;
      }).catch(() => {});

      // get data
      apiRequest({
        module: 'geocoding',
        service: 'get_points_v2',
        params: this.searchParameters,
      }).then((response) => {
        this.suborders = response.data.map((e) => {
          e.selected = false;
          e.gridData = [];
          e.waitingUpdate = false;
          return e;
        });
        if (this.suborders.length > 0) {
          this.suborders[0].selected = true;
          this.setPlace(this.suborders[0]);
          this.oneSelected = true;
        } else {
          this.defaultPlace();
        }
        this.totalSize = parseInt(response.headers['x-total-count'], 10);
        this.dataCalled = true;
        this.loading = false;
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding_list',
          action: 'search_completed',
          status: response.data.length === 0 ? 'empty' : 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            total_size: this.totalSize,
            page_size: this.pageSize,
            regions_count: params.regions ? params.regions.length : 0,
            localities_count: params.localities ? params.localities.length : 0,
            geo_types_count: params.geoTypes ? params.geoTypes.length : 0,
          },
        });
        if (this.totalSize > this.pageSize) {
          setTimeout(() => this.partialPoints(), 0);
        }
      }).catch((error) => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'manual_geocoding_list',
          action: 'search_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            page_size: this.pageSize,
          },
        });
        this.$notify.error({
          title: 'Error',
          message: `Error al obtener puntos ${error}`,
        });
        this.loading = false;
      });
    },
    loadOneMore() {
      trackBusinessFlow({
        module: 'geocoding',
        flow: 'manual_geocoding_list',
        action: 'load_more_requested',
        status: 'attempt',
        context: {
          current_size: this.currentSize,
          total_size: this.totalSize,
          page_size: this.pageSize,
        },
      });
      setTimeout(() => this.partialPoints(0));
    },
    partialPoints() {
      // eslint-disable-next-line no-plusplus
      this.partialLoad = true;
      const pr = this.searchParameters;
      pr.offset = this.currentSize;
      pr.size = this.pageSize;
      apiRequest({
        module: 'geocoding',
        service: 'get_points_v2',
        params: pr,
      }).then((response) => {
        response.data.forEach((e) => {
          e.selected = false;
          e.gridData = [];
          e.waitingUpdate = false;
          this.suborders.push(e);
        });
        this.totalSize = parseInt(response.headers['x-total-count'], 10);
        this.partialLoad = false;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener puntos',
        });
        this.partialLoad = false;
      });
    },
    getLimitPage(page) {
      return ((page - 1) * 10);
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1;
    },
    handleSizeChange(val) {
      this.currentPage = 0;
      this.pageSize = val;
      sessionStorage.setItem('GL:pageSize', val.toString());
    },
    getImgUrl(img) {
      const images = require.context('../../assets/img/', false);
      return images(`./${img}`);
    },
    clickRow(row) {
      this.$notify.error({
        title: 'Error',
        message: row,
      });
      this.place = {
        point_id: row.point_id,
        address: `${row.address}, ${row.commune}`,
        position: {
          lat: row.latitude,
          lng: row.longitude,
        },
        commune: '',
        locality: '',
      };
    },
  },
  computed: {
    currentSize() {
      return this.suborders.length;
    },
    subSocs() {
      const init = this.currentPage * this.pageSize;
      const end = (this.currentPage + 1) * this.pageSize;
      return this.suborders.slice(init, end);
    },
    currentProgress() {
      const percent = this.currentSize > 0 && this.totalSize > 0
        ? Math.round((this.currentSize / this.totalSize) * 100)
        : 0;
      return percent;
    },
  },
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
  },
  created() {
    this.defaultPlace();
    if (sessionStorage.getItem('GL:pageSize')) {
      this.pageSize = parseInt(sessionStorage.getItem('GL:pageSize'), 10);
    }
  },
};
</script>

<style lang="scss" scoped>
  .top-container {
    display: flex;
    padding: 0 0 10px;
    justify-content: flex-start;
  }
  .sideForm {
    padding: 0 0 10px 5px;
  }
  .el-button.btn.primary {
    height: 40px;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100% !important;
  }
  .clientInfoContainer {
    display: flex;
    margin-right: 10px;
  }
  .clientInfo {
    padding: 10px;
    background: white;
    border: 3px solid $fb-grey-light-97;
  }
  .label {
    text-transform: uppercase;
    font-size: 10px;
    color: #606266;
    display: inline-block;
    text-align: left;
    line-height: 12px;
    vertical-align: bottom;
    font-weight: 700;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: $fb-green;
    &.small {
      display: block;
      font-style: italic;
      font-size: 0.85em;
    }
  }
  .tooltipStyle {
    color: $fb-green;
    font-size: 16px;
    vertical-align: bottom;
  }
  .progress-bar {
    margin-bottom: 0;
  }
  .tooltipMarker {
    color: $fb-green;
    font-size: 16px;
    margin-left: 5px;
  }
  .fas.fa-info-circle {
    font-size: 13px;
    margin-left: 5px;
  }
  .iconsSitesContainer {
    display: flex;
    margin-left: 15px;
    justify-content: center;
  }
  .iconSiteContainer {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
    }
  }
  .card-section {
    padding: 7px;
    background-color: #fafafa;
    box-shadow: inset 0 0 20px 0 rgba(0, 0, 0, 0.05);
    .container-sectors {
      width: 100%;
      display: table;
    }
    .msg-not-sector {
      font-size: 12px;
      font-weight: 700;
    }
  }
  .right { float: right; }
  .list-action-btn {
    border: none;
    i { font-weight: 900; }
    span { margin-left: 7px;}
  }
  .container {
    margin-top: 0.3em;
  }
  .plus-btn {
    margin-top: 2px;
  }
  .count-text {
    font-size: 11px;
    color: $fb-grey-light-50;
    div.right {
      padding-right: 10px;
      float: right;
      span {
        font-weight: bold;
        color: $fb-green;
      }
    }
    div.left {
      padding-left: 30px;
      float: left;
      span {
        font-weight: bold;
        color: $fb-green;
      }
    }
  }
  .user-info { margin: 10px; }
  .submit-box {
    margin-top: 20px;
    align-items: center;
  }
  .one-col > .el-col { padding: 10px 30px 25px 30px; }
</style>
